import { Observable, of, Subject, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class DoctorService {
  SharingData = new Subject();  
  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  getDoctorList(pageno,limit,qstring)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-doctor-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  addDoctor(data)
  {
  	var formData: any = new FormData();
  	for (const key in data) 
    { 
      if(key=='additional_location'){
        data[key]=JSON.stringify(data[key]);
      }
      formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-doctor',formData,{headers:webheader})
  }

  DoctorOtherInfo(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'doctor-other-info',data,{headers:webheader})
  }

  getDoctorOtherInfo(data){
    let doctor_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-doctor-other-info/'+ doctor_id, {headers:webheader})
  }





  getDoctorData(data){
    let doctor_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-doctor-data/'+ doctor_id, {headers:webheader})
  }
  
  updateDoctorOrder(data){
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-doctor-order-data',data,{headers:webheader})
  }

  updateDoctor(data)
  {
    var formData: any = new FormData();
  	for (const key in data) 
    { 
      if(key=='additional_location'){
        data[key]=JSON.stringify(data[key]);
      }
      formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-doctor-data',formData,{headers:webheader})
  } 

  uploadDoctorFile(doctor_id,formData)
  {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'upload-doctor-docs/'+doctor_id,formData,{headers:webheader})
  }
  
  getCircle_cities(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-circle-wisecity?'+data,{headers:webheader})
  }

  updateDoctorStatus(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-doctor-status',data,{headers:webheader})
  }

  addTreatmentCost(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-doctor-TreatmentCost',data,{headers:webheader})
  }

  updateTreatmentCost(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-doctor-TreatmentCost',data,{headers:webheader})
  }

  getTreatmentcostList(doctor_id){
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-doctor-treatment-cost-list/'+ doctor_id,{headers:webheader})
  }
  getDoctorDiariesList(doctor_id){
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-doctor-diaries-list/'+ doctor_id,{headers:webheader})
  }

  getTreatCostData(record_id){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-doctor-treatCost-data/'+ record_id, {headers:webheader})
  }
  getDoctorDiaryData(record_id){
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-doctor-diary-data/'+ record_id, {headers:webheader})
  }

  deletedoctordiariesfiles(diary_id, file_type)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'delete-doctor-diary-files/'+diary_id+'/'+file_type,{headers:webheader})
  }

  showingOnLP(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'display-doctor-lp',data,{headers:webheader})
  }

  updateDoctorDiaries(data)
  {
    var formData: any = new FormData();
  	for (const key in data) 
    { 
      formData.append(key, data[key]);
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-doctor-diaries-data',formData,{headers:webheader})
  } 

//--------------------Doctor Appointment----------------//

  saveAppointment(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'doctor-appointment',data,{headers:webheader})
  }
  getDocAppData(data)
  {
    let doctor_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-doctor-appointment-data/'+doctor_id,{headers:webheader})
  }

  getAppEditData(data)
  {
    let date_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-update-appointment-data/'+date_id,{headers:webheader})
  }


  deleteApp(data)
  {
    let date_id = data.id;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'delete-appointment-data/'+date_id,{headers:webheader})
  }
 //--------------------Doctor Out Of Work----------------//
 saveOutOfWork(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'doctor-out-of-work-date',data,{headers:webheader})
  }
  
  getDocOutWorkData(data)
  {
    let doctor_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-doctor-out-of-work-data/'+doctor_id,{headers:webheader})
  }
  
  getOutWorkEditData(data)
  {
    let date_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-update-out-of-work-data/'+date_id,{headers:webheader})
  }


  deleteOutWorkData(data)
  {
    let date_id = data.id;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'delete-out-of-work-data/'+date_id,{headers:webheader})
  }


// -----------------------------Featured Specialties------------------------------//
 get_Featured_Specialties()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-featured-specialties',{headers:webheader})
  }

  uploadcsvDoctorRankingUpdate(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'import-doctor-ranking-update-csv',data,{headers:webheader})
  }
//--------------------Doctor Appointment Duration----------------//
save_appointment_duration(data)
{
  let webheader = this.sharedapi.getHeaders();
  return this.http.post(apiUrl+'doctor-appointment-duration',data,{headers:webheader})
}
//--------------------Circle Wise Hospital----------------//
getCircle_wise_hospital(data)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-circle-wise-hospital?'+data,{headers:webheader})
}
//--------------------Update Doctor All Field Csv(Import)----------------//
uploadDoctorUpdateCsv(data)
{
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'import-doctor-data-update-csv',data,{headers:webheader})
}

//--------------------Delete Doctor Document----------------//
deleteDocuments(data)
{
  let document_id = data.id;
  let webheader = this.sharedapi.getHeaders();
  return this.http.delete(apiUrl+'delete-doctor-document/'+document_id,{headers:webheader})
}
}
